import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Images from "../../../media/images";
import sidebar from "../../../pages/staffSidebar/Array";
import BackButton from "../../common/backbutton/BackButton";
import api from '../../../api/api'

const StafSidebar = () => {
  const [openedFolder, setOpenedFolder] = useState([]);
  const [newSidebar, setNewSidebar] = useState([]);


  // retrieving permission based on user
  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    api 
      .get("/users/me/")
      .then((response) => {
        let perms = response.data[0].groups[0].permissions

        let obj = [];
        perms
          .map((item) => item.model)
          .filter((perm, i) => {
            if (i === 0) {
              obj.push(perm);
            } else {
              if (perm === perm[i - 1]) {
                obj.push(perm);
              }
            }
          });

        setPermissions(obj);
      })
      .catch((error) => {});
  }, []);


  

  // based on permission create new sidebar
  useEffect(() => {
  
    const user = JSON.parse(localStorage.getItem("user"));

    if(permissions.length > 0 ) {
      
    let newData = sidebar.map((item, i) => {
  
      let childrens = [];

      item?.chidren?.map((child) => {
        if (permissions.includes(child.model) || child.model === "all") {
          childrens.push(child);
        }
      });

      if(childrens.length > 0) {
        item.chidren = childrens;
        return item;
      }else{
        return null
      }
      
    });

    let newBar =  newData.filter(item => item !== null)

    setNewSidebar(newBar)

  }else if(user.user_type === "AD") {
    setNewSidebar(sidebar)
  }
   
  }, [permissions, sidebar]);



  

  const openFolder = (index) => {
    if (openedFolder.some((idx) => idx === index)) {
      setOpenedFolder(openedFolder.filter((item) => item !== index));
    } else {
      setOpenedFolder([...openedFolder, index]);
    }
  };

  const checkIsOpened = (index) => {
    if (openedFolder.some((idx) => idx === index)) return true;
    else return false;
  };

  return (
    <div className="sticky  top-28">
      <aside className="hidden font-Bree  col-span-1  sm:h-[33rem] md:h-[36rem] select-none flex-col justify-start overflow-y-scroll bg-white xl:!flex">
        <Link
          to="/staff"
          className="text-primary-blue font-Rakkas mt-11 text-center font-bold md:text-2xl"
        >
          Staff Dashboard
        </Link>
        {/* task assigned */}
        <div className="mt-3">
          {newSidebar.map((item, index) => {
            return (
              <div key={index}>
                <div
                  className="dropdown-header text-primary-red"
                  onClick={() => {
                    openFolder(index);
                  }}
                >
                  {!checkIsOpened(index) ? (
                    <>
                      <img alt="" className="h-5 w-5" src={Images.plusIcon} />
                      <img
                        src={Images.folderCloseIcon}
                        className="h-5 w-5"
                        alt=""
                      />
                    </>
                  ) : (
                    <>
                      <img alt="" className="h-5 w-5" src={Images.minusIcon} />
                      <img
                        src={Images.folderOpenIcon}
                        className="h-5 w-5"
                        alt=""
                      />
                    </>
                  )}
                  {item.name}
                </div>
                {item.chidren.length > 0 &&
                  item.chidren.map((childItem, idx) => {
                    return (
                      <div
                        className={`flex py-2 pl-4 gap-2 justify-start ${
                          checkIsOpened(index) ? "block" : "hidden"
                        } dropdown-item-bg`}
                        key={idx}
                      >
                        <img
                          src={Images.fileIcon}
                          className="h-5 w-5"
                          alt="noload"
                        />
                        <Link
                          to={`/staff/${childItem.link}`}
                          className="text-sm"
                        >
                          {" "}
                          {childItem.name}
                        </Link>
                      </div>
                    );
                  })}
              </div>
            );
          })}
        </div>
      </aside>
    </div>
  );
};

export default StafSidebar;
